import { DeleteOutlined } from '@ant-design/icons';
import { Button, Popconfirm, message } from 'antd';
import { FC, useCallback, useState } from 'react';
import { errorObjectToString } from 'src/utils/common';
import { deleteProductInventory } from 'src/utils/firebase/firebase-short-cut';

type AgCellDeleteInventoryProps = {
  id: string;
  disabled?: boolean;
};

const AgCellDeleteInventory: FC<AgCellDeleteInventoryProps> = ({ id, disabled }) => {
  const [loading, setLoading] = useState(false);

  const handleOnClick = useCallback(async () => {
    setLoading(true);
    try {
      await deleteProductInventory(id);
      message.success('삭제 완료');
    } catch (error) {
      console.error(error);
      message.error(errorObjectToString(error));
    }
    setLoading(false);
  }, [id]);

  return (
    <Popconfirm
      disabled={disabled}
      placement='bottomRight'
      title='삭제하시겠습니까?'
      onConfirm={handleOnClick}
      okText='삭제'
      cancelText='취소'
      okButtonProps={{ loading, danger: true }}>
      <Button
        size='small'
        type='primary'
        danger
        loading={loading}
        disabled={disabled}
        style={{ fontSize: 12, marginLeft: 4 }}
        icon={<DeleteOutlined />}>
        삭제
      </Button>
    </Popconfirm>
  );
};

export default AgCellDeleteInventory;
